<template>
    <div v-if="general_setting_status == 'success' && accounts_status == 'success'">
        <form @submit.prevent="updateSettings" id="update_accounts_setting_form">
            <kt-row>
                <kt-col xs="12" sm="6" md="6">
                    <kt-form-group>
                        <kt-form-label for="destination_account_id">
                            {{ $t('deposit.destination_account_id') }}
                        </kt-form-label>
                        <select
                                id="destination_account_id"
                                name="destination_account_id"
                                class="form-control kt-selectpicker"
                                v-model="general_setting.destination_account_id"
                        >
                            <option
                                    :selected="general_setting.destination_account_id == account.id "
                                    v-bind:key="index"
                                    v-for="(account, index) in bank_accounts"
                                    :value="account.id"
                            >
                                {{ account.sheba}}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6">
                    <kt-form-group>
                        <kt-form-label for="destination_bank">
                            {{ $t('deposit.destination_bank') }}
                        </kt-form-label>
                        <kt-form-select
                                id="destination_bank"
                                name="destination_bank"
                                class="form-control kt-selectpicker"
                                v-on:change="setBankAccounts"
                                v-model="general_setting.destination_bank"
                        >
                            <option
                                    :selected="general_setting.destination_bank == bank"
                                    v-bind:key="bank"
                                    v-for="bank in depositDestinationBanks"
                                    :value="bank"
                            >
                                {{ depositDestinationBankStr.get(bank) }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" sm="12" style="margin-top: 15px">
                    <div class="custom-control custom-switch">
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="need_authentication"
                                name="need_authentication"
                                v-model="general_setting.need_authentication"
                        >
                        <label class="custom-control-label" for="need_authentication">
                            {{ $t('deposit.need_authentication_status') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row style="float: left;">
            <button
                    type="submit"
                    class="btn btn-success"
                    id="update_accounts_setting_btn"
                    v-text="$t('btn.submit_changes')"
            >
            </button>
            </kt-row>
        </form>
    </div>
</template>

<script>
import $ from "jquery";
import {KTApp} from '@/plugins/core/app';
import { depositPfService, depositStarshopService } from "@/common/api.service"
import {depositDestinationBanks,depositDestinationBankStr} from "@/constants/deposit";
import {i18n} from "@/plugins/i18n";
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            depositDestinationBanks,depositDestinationBankStr,
            bank_accounts :[],
            depositPfService,
            depositStarshopService
        };
    },
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
        ...mapGetters('deposit', [
            'accounts',
            'general_setting',
            'accounts_status',
            'general_setting_status'
        ]),
    },
    mounted() {
        this.$store.dispatch('deposit/getGeneralSetting', this.gatewaySource === 'starshop' )
        this.$store.dispatch('deposit/getAccounts', this.gatewaySource === 'starshop')
        this.runSelectPicker()
    },
    watch: {
        accounts_status: {
            handler(newValue, oldValue) {
                if (newValue == 'success' && this.general_setting_status == 'success')
                    this.setBankAccounts(true)
            }
        },
        general_setting_status: {
            handler(newValue, oldValue) {
                if (newValue == 'success' && this.accounts_status == 'success')
                    this.setBankAccounts(true)
            }
        }
    },
    methods: {
        updateSettings(e) {
            let btn = $('#update_accounts_setting_btn');
            let form = $('#update_accounts_setting_form');

            form.validate({
                rules: {
                    destination_account_id: {
                        required: true
                    },
                    destination_bank: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                return
            }

            KTApp.progress(btn);

            this.apiService.updateGeneralSetting({
                destination_account_id: this.general_setting.destination_account_id,
                destination_bank: this.general_setting.destination_bank,
                need_authentication: this.general_setting.need_authentication,
            }).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(response => {
                KTApp.unprogress(btn);
            })
        },
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        setBankAccounts(is_first_set) {
            this.bank_accounts = []
            if (!is_first_set)
                this.general_setting.destination_account_id = ''
            this.accounts.forEach((account) => {
                if (account.bank_name == this.general_setting.destination_bank)
                    this.bank_accounts.push(account)
            })
        }
    },
}
</script>

<style>
</style>
